import React from "react";
import { Link, RouteComponentProps } from "@reach/router";

import classNames from "classnames";
import styles from "../link-app.module.css";

const SuccessPage: React.FC<RouteComponentProps> = () => (
  <div className={styles.container}>
    <div className={classNames("text-center", styles.heading)}>
      <h2 className={styles.h2}>Success!</h2>
      <p className={styles.largePara}>
        You&apos;ve created a Haven Connect account. Please <Link to="/login">Click Here</Link> to
        log in and update your information. It&apos;s very important to do so in order to have the
        best chance of staying on the list.
      </p>
    </div>
  </div>
);

export default SuccessPage;
